import { TelemetryContext } from "../components/TelemetryProvider.js";
import { useContext } from "react";

//#region src/react/hooks/use-telemetry-context.ts
const useTelemetryContext = () => {
	const ctx = useContext(TelemetryContext);
	if (ctx === null) throw new Error("useTelemetryContext() cannot be called outside of a TelemetryProvider");
	return ctx;
};

//#endregion
export { useTelemetryContext };